import { ButtonPrimary } from '@fukku/button/Primary'
import { ButtonSecondary } from '@fukku/button/Secondary'
import type { DialogAPI } from '@fukku/dialog'
import { BottomSheet } from '@fukku/dialog/BottomSheet'
import { Content } from '@fukku/dialog/Content'
import { Header } from '@fukku/dialog/Header'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { useEffect, useRef } from 'react'

import styles from './ChatModalCloseConfirm.module.scss'

interface ChatModalConfirmProps {
	readonly onCancelLeave: () => void
	readonly onLeave: () => void
	readonly isExitOpen: boolean
}

export function ChatModalCloseConfirm({
	onCancelLeave,
	onLeave,
	isExitOpen,
}: ChatModalConfirmProps) {
	const { t } = useLabels()

	const sheetRef = useRef<DialogAPI>(null)

	useEffect(() => {
		if (isExitOpen) {
			sheetRef.current?.show()
		}
	}, [isExitOpen])

	return (
		<BottomSheet
			ref={sheetRef}
			title={t('assistant.close.title')}
			data-testid='colorsSelectorSheet'
			onClose={onCancelLeave}
		>
			<Header
				title={t('assistant.close.title')}
				subtitle={t('assistant.close.bodycopy')}
			/>
			<Content className={styles.chatModalCloseConfirm}>
				<ButtonPrimary className={styles.leaveButton} onClick={onLeave}>
					{t('assistant.close.confirm.button')}
				</ButtonPrimary>
				<ButtonSecondary onClick={onCancelLeave}>
					{t('assistant.close.cancel.button')}
				</ButtonSecondary>
			</Content>
		</BottomSheet>
	)
}
